var map = {
	"./Aircraft/Airliner_Black.png": 86,
	"./Aircraft/Airliner_Blue.png": 1044,
	"./Aircraft/Airliner_Green.png": 1045,
	"./Aircraft/Airliner_Grey.png": 1046,
	"./Aircraft/Airliner_Red.png": 1047,
	"./Aircraft/Airliner_Yellow.png": 1048,
	"./Aircraft/Airplane_Black.png": 1049,
	"./Aircraft/Airplane_Blue.png": 1050,
	"./Aircraft/Airplane_Green.png": 1051,
	"./Aircraft/Airplane_Grey.png": 1052,
	"./Aircraft/Airplane_Red.png": 1053,
	"./Aircraft/Airplane_Yellow.png": 1054,
	"./Aircraft/Helicopter_Black.png": 1055,
	"./Aircraft/Helicopter_Blue.png": 1056,
	"./Aircraft/Helicopter_Green.png": 1057,
	"./Aircraft/Helicopter_Grey.png": 1058,
	"./Aircraft/Helicopter_Red.png": 1059,
	"./Aircraft/Helicopter_Yellow.png": 1060,
	"./Arrows/093-chevron-1.png": 1061,
	"./Arrows/093-chevron-10.png": 1062,
	"./Arrows/093-chevron-11.png": 1063,
	"./Arrows/093-chevron-2.png": 1064,
	"./Arrows/093-chevron-3.png": 1065,
	"./Arrows/093-chevron-4.png": 1066,
	"./Arrows/093-chevron-5.png": 1067,
	"./Arrows/093-chevron-6.png": 1068,
	"./Arrows/093-chevron-7.png": 1069,
	"./Arrows/093-chevron-8.png": 1070,
	"./Arrows/093-chevron-9.png": 1071,
	"./Arrows/093-chevron.png": 1072,
	"./Arrows/093-compress-1.png": 1073,
	"./Arrows/093-compress.png": 1074,
	"./Arrows/093-curved-arrow-1.png": 1075,
	"./Arrows/093-curved-arrow-2.png": 1076,
	"./Arrows/093-curved-arrow-3.png": 1077,
	"./Arrows/093-curved-arrow.png": 1078,
	"./Arrows/093-diagonal-arrow-1.png": 1079,
	"./Arrows/093-diagonal-arrow-10.png": 1080,
	"./Arrows/093-diagonal-arrow-11.png": 1081,
	"./Arrows/093-diagonal-arrow-12.png": 1082,
	"./Arrows/093-diagonal-arrow-13.png": 1083,
	"./Arrows/093-diagonal-arrow-14.png": 1084,
	"./Arrows/093-diagonal-arrow-15.png": 1085,
	"./Arrows/093-diagonal-arrow-2.png": 1086,
	"./Arrows/093-diagonal-arrow-3.png": 1087,
	"./Arrows/093-diagonal-arrow-4.png": 1088,
	"./Arrows/093-diagonal-arrow-5.png": 1089,
	"./Arrows/093-diagonal-arrow-6.png": 1090,
	"./Arrows/093-diagonal-arrow-7.png": 1091,
	"./Arrows/093-diagonal-arrow-8.png": 1092,
	"./Arrows/093-diagonal-arrow-9.png": 1093,
	"./Arrows/093-diagonal-arrow.png": 1094,
	"./Arrows/093-down-arrow-1.png": 1095,
	"./Arrows/093-down-arrow-2.png": 1096,
	"./Arrows/093-down-arrow-3.png": 1097,
	"./Arrows/093-down-arrow-4.png": 1098,
	"./Arrows/093-down-arrow-5.png": 1099,
	"./Arrows/093-down-arrow.png": 1100,
	"./Arrows/093-exchange-1.png": 1101,
	"./Arrows/093-exchange.png": 1102,
	"./Arrows/093-expand-1.png": 1103,
	"./Arrows/093-expand-2.png": 1104,
	"./Arrows/093-expand-3.png": 1105,
	"./Arrows/093-expand.png": 1106,
	"./Arrows/093-left-arrow-1.png": 1107,
	"./Arrows/093-left-arrow-2.png": 1108,
	"./Arrows/093-left-arrow-3.png": 1109,
	"./Arrows/093-left-arrow-4.png": 1110,
	"./Arrows/093-left-arrow-5.png": 1111,
	"./Arrows/093-left-arrow-6.png": 1112,
	"./Arrows/093-left-arrow.png": 1113,
	"./Arrows/093-move-1.png": 1114,
	"./Arrows/093-move.png": 1115,
	"./Arrows/093-redo-1.png": 1116,
	"./Arrows/093-redo.png": 1117,
	"./Arrows/093-resize-1.png": 1118,
	"./Arrows/093-resize-2.png": 1119,
	"./Arrows/093-resize-3.png": 1120,
	"./Arrows/093-resize.png": 1121,
	"./Arrows/093-right-arrow-1.png": 1122,
	"./Arrows/093-right-arrow-2.png": 1123,
	"./Arrows/093-right-arrow-3.png": 1124,
	"./Arrows/093-right-arrow-4.png": 1125,
	"./Arrows/093-right-arrow-5.png": 1126,
	"./Arrows/093-right-arrow-6.png": 1127,
	"./Arrows/093-right-arrow-7.png": 1128,
	"./Arrows/093-right-arrow.png": 1129,
	"./Arrows/093-scroll-1.png": 1130,
	"./Arrows/093-scroll.png": 1131,
	"./Arrows/093-sort-1.png": 1132,
	"./Arrows/093-sort-2.png": 1133,
	"./Arrows/093-sort-3.png": 1134,
	"./Arrows/093-sort.png": 1135,
	"./Arrows/093-turn-left-1.png": 1136,
	"./Arrows/093-turn-left-2.png": 1137,
	"./Arrows/093-turn-left-3.png": 1138,
	"./Arrows/093-turn-left.png": 1139,
	"./Arrows/093-turn-right-1.png": 1140,
	"./Arrows/093-turn-right-2.png": 1141,
	"./Arrows/093-turn-right-3.png": 1142,
	"./Arrows/093-turn-right.png": 1143,
	"./Arrows/093-undo-1.png": 1144,
	"./Arrows/093-undo.png": 1145,
	"./Arrows/093-up-arrow-1.png": 1146,
	"./Arrows/093-up-arrow-2.png": 1147,
	"./Arrows/093-up-arrow-3.png": 1148,
	"./Arrows/093-up-arrow-4.png": 1149,
	"./Arrows/093-up-arrow-5.png": 1150,
	"./Arrows/093-up-arrow-6.png": 1151,
	"./Arrows/093-up-arrow.png": 1152,
	"./Assets/151-actions.png": 1153,
	"./Assets/151-advert.png": 1154,
	"./Assets/151-antennas.png": 1155,
	"./Assets/151-archives.png": 1156,
	"./Assets/151-attached.png": 1157,
	"./Assets/151-banker.png": 1158,
	"./Assets/151-barrow.png": 1159,
	"./Assets/151-bed-side.png": 1160,
	"./Assets/151-beds.png": 1161,
	"./Assets/151-blackboard.png": 1162,
	"./Assets/151-blocked.png": 1163,
	"./Assets/151-book-bag-1.png": 1164,
	"./Assets/151-book-bag.png": 1165,
	"./Assets/151-bridges.png": 1166,
	"./Assets/151-calculations.png": 1167,
	"./Assets/151-carrier.png": 1168,
	"./Assets/151-ceremonial.png": 1169,
	"./Assets/151-chairs.png": 1170,
	"./Assets/151-cleaned.png": 1171,
	"./Assets/151-closing.png": 1172,
	"./Assets/151-cooling.png": 1173,
	"./Assets/151-demostration.png": 1174,
	"./Assets/151-deposit.png": 1175,
	"./Assets/151-dialogue.png": 1176,
	"./Assets/151-disturbance.png": 1177,
	"./Assets/151-domestic-phone.png": 1178,
	"./Assets/151-door-key.png": 1179,
	"./Assets/151-door.png": 1180,
	"./Assets/151-doorway.png": 1181,
	"./Assets/151-draws.png": 1182,
	"./Assets/151-driller.png": 1183,
	"./Assets/151-electric-1.png": 1184,
	"./Assets/151-electric-2.png": 1185,
	"./Assets/151-electric.png": 1186,
	"./Assets/151-entrance.png": 1187,
	"./Assets/151-facade-1.png": 1188,
	"./Assets/151-facade.png": 1189,
	"./Assets/151-fader.png": 1190,
	"./Assets/151-file-storage.png": 1191,
	"./Assets/151-fireplace-1.png": 1192,
	"./Assets/151-fireplace.png": 1193,
	"./Assets/151-flats-1.png": 1194,
	"./Assets/151-flats.png": 1195,
	"./Assets/151-frame.png": 1196,
	"./Assets/151-garden-work.png": 1197,
	"./Assets/151-gardener.png": 1198,
	"./Assets/151-gardening.png": 1199,
	"./Assets/151-glamour.png": 1200,
	"./Assets/151-graphic-design.png": 1201,
	"./Assets/151-graphs.png": 1202,
	"./Assets/151-hacksaw.png": 1203,
	"./Assets/151-hand-gesture.png": 1204,
	"./Assets/151-hand-phones.png": 1205,
	"./Assets/151-headphones.png": 1206,
	"./Assets/151-health-care.png": 1207,
	"./Assets/151-hearth.png": 1208,
	"./Assets/151-house-things-1.png": 1209,
	"./Assets/151-house-things-2.png": 1210,
	"./Assets/151-house-things.png": 1211,
	"./Assets/151-house.png": 1212,
	"./Assets/151-houses.png": 1213,
	"./Assets/151-indoor.png": 1214,
	"./Assets/151-industrial-park.png": 1215,
	"./Assets/151-industrial.png": 1216,
	"./Assets/151-interior-design.png": 1217,
	"./Assets/151-invention.png": 1218,
	"./Assets/151-keyword.png": 1219,
	"./Assets/151-kilograms.png": 1220,
	"./Assets/151-ladders.png": 1221,
	"./Assets/151-line-chart.png": 1222,
	"./Assets/151-lover.png": 1223,
	"./Assets/151-mail.png": 1224,
	"./Assets/151-mailed.png": 1225,
	"./Assets/151-mallet.png": 1226,
	"./Assets/151-mansory.png": 1227,
	"./Assets/151-maps-and-flags-1.png": 1228,
	"./Assets/151-maps-and-flags-2.png": 1229,
	"./Assets/151-maps-and-flags-3.png": 1230,
	"./Assets/151-maps-and-flags-4.png": 1231,
	"./Assets/151-maps-and-flags-5.png": 1232,
	"./Assets/151-maps-and-flags-6.png": 1233,
	"./Assets/151-maps-and-flags.png": 1234,
	"./Assets/151-measuring-1.png": 1235,
	"./Assets/151-measuring.png": 1236,
	"./Assets/151-mechanics.png": 1237,
	"./Assets/151-metallic-blind.png": 1238,
	"./Assets/151-money-icons.png": 1239,
	"./Assets/151-monumental.png": 1240,
	"./Assets/151-motorhome.png": 1241,
	"./Assets/151-online-store.png": 1242,
	"./Assets/151-packaging.png": 1243,
	"./Assets/151-paint-roller.png": 1244,
	"./Assets/151-painted.png": 1245,
	"./Assets/151-paper-printer.png": 1246,
	"./Assets/151-paper-work.png": 1247,
	"./Assets/151-picket.png": 1248,
	"./Assets/151-pincers.png": 1249,
	"./Assets/151-plan.png": 1250,
	"./Assets/151-plans.png": 1251,
	"./Assets/151-plumbering-1.png": 1252,
	"./Assets/151-plumbering.png": 1253,
	"./Assets/151-printed.png": 1254,
	"./Assets/151-property.png": 1255,
	"./Assets/151-pruners.png": 1256,
	"./Assets/151-purses.png": 1257,
	"./Assets/151-radiators.png": 1258,
	"./Assets/151-reading-glasses.png": 1259,
	"./Assets/151-real-estate-1.png": 1260,
	"./Assets/151-real-estate-2.png": 1261,
	"./Assets/151-real-estate-3.png": 1262,
	"./Assets/151-real-estate-4.png": 1263,
	"./Assets/151-real-estate-5.png": 1264,
	"./Assets/151-real-estate-6.png": 1265,
	"./Assets/151-real-estate.png": 1266,
	"./Assets/151-relax.png": 1267,
	"./Assets/151-religious.png": 1268,
	"./Assets/151-rent.png": 1269,
	"./Assets/151-reparation.png": 1270,
	"./Assets/151-roof.png": 1271,
	"./Assets/151-sand-clock.png": 1272,
	"./Assets/151-savings.png": 1273,
	"./Assets/151-security-system-1.png": 1274,
	"./Assets/151-security-system.png": 1275,
	"./Assets/151-seventeen.png": 1276,
	"./Assets/151-shower.png": 1277,
	"./Assets/151-single.png": 1278,
	"./Assets/151-sit-down.png": 1279,
	"./Assets/151-skyline.png": 1280,
	"./Assets/151-step-ladder.png": 1281,
	"./Assets/151-storehouse.png": 1282,
	"./Assets/151-studying.png": 1283,
	"./Assets/151-switch-off.png": 1284,
	"./Assets/151-text-file.png": 1285,
	"./Assets/151-title.png": 1286,
	"./Assets/151-tools-and-utensils.png": 1287,
	"./Assets/151-transportation.png": 1288,
	"./Assets/151-trees.png": 1289,
	"./Assets/151-trucks-1.png": 1290,
	"./Assets/151-trucks.png": 1291,
	"./Assets/151-turned-off.png": 1292,
	"./Assets/151-up-1.png": 1293,
	"./Assets/151-up-2.png": 1294,
	"./Assets/151-up.png": 1295,
	"./Assets/151-ventilation.png": 1296,
	"./Assets/151-wc.png": 1297,
	"./Assets/151-wheel-chair.png": 1298,
	"./Assets/151-wheelbarrow.png": 1299,
	"./Assets/151-winch.png": 1300,
	"./Assets/151-work-tools.png": 1301,
	"./Assets/151-worker.png": 1302,
	"./Bikes/Bicycle_Black.png": 1303,
	"./Bikes/Bicycle_Blue.png": 1304,
	"./Bikes/Bicycle_Green.png": 1305,
	"./Bikes/Bicycle_Grey.png": 1306,
	"./Bikes/Bicycle_Red.png": 1307,
	"./Bikes/Bicycle_Yellow.png": 1308,
	"./Bikes/CruiserMotorcycle_Black.png": 1309,
	"./Bikes/CruiserMotorcycle_Blue.png": 1310,
	"./Bikes/CruiserMotorcycle_Green.png": 1311,
	"./Bikes/CruiserMotorcycle_Grey.png": 1312,
	"./Bikes/CruiserMotorcycle_Red.png": 1313,
	"./Bikes/CruiserMotorcycle_Yellow.png": 1314,
	"./Bikes/Motorcycle_Black.png": 1315,
	"./Bikes/Motorcycle_Blue.png": 1316,
	"./Bikes/Motorcycle_Green.png": 1317,
	"./Bikes/Motorcycle_Grey.png": 1318,
	"./Bikes/Motorcycle_Red.png": 1319,
	"./Bikes/Motorcycle_Yellow.png": 1320,
	"./Bikes/QuadBike_Black.png": 1321,
	"./Bikes/QuadBike_Blue.png": 1322,
	"./Bikes/QuadBike_Green.png": 1323,
	"./Bikes/QuadBike_Grey.png": 1324,
	"./Bikes/QuadBike_Red.png": 1325,
	"./Bikes/QuadBike_Yellow.png": 1326,
	"./Bikes/Scooter_Black.png": 1327,
	"./Bikes/Scooter_Blue.png": 1328,
	"./Bikes/Scooter_Green.png": 1329,
	"./Bikes/Scooter_Grey.png": 1330,
	"./Bikes/Scooter_Red.png": 1331,
	"./Bikes/Scooter_Yellow.png": 1332,
	"./Bikes/TouringMotorcycle_Black.png": 1333,
	"./Bikes/TouringMotorcycle_Blue.png": 1334,
	"./Bikes/TouringMotorcycle_Gray.png": 1335,
	"./Bikes/TouringMotorcycle_Green.png": 1336,
	"./Bikes/TouringMotorcycle_Red.png": 1337,
	"./Bikes/TouringMotorcycle_Yellow.png": 1338,
	"./Car/Cabriolet_Black.png": 1339,
	"./Car/Cabriolet_Blue.png": 1340,
	"./Car/Cabriolet_Green.png": 1341,
	"./Car/Cabriolet_Grey.png": 1342,
	"./Car/Cabriolet_Red.png": 1343,
	"./Car/Cabriolet_Yellow.png": 1344,
	"./Car/CamperVan_Black.png": 1345,
	"./Car/CamperVan_Blue.png": 1346,
	"./Car/CamperVan_Green.png": 1347,
	"./Car/CamperVan_Grey.png": 1348,
	"./Car/CamperVan_Red.png": 1349,
	"./Car/CamperVan_Yellow.png": 1350,
	"./Car/Car_Black.png": 1351,
	"./Car/Car_Blue.png": 1352,
	"./Car/Car_Green.png": 1353,
	"./Car/Car_Grey.png": 1354,
	"./Car/Car_Red.png": 1355,
	"./Car/Car_Yellow.png": 1356,
	"./Car/ExecutiveCar_Black.png": 1357,
	"./Car/ExecutiveCar_Blue.png": 1358,
	"./Car/ExecutiveCar_Green.png": 1359,
	"./Car/ExecutiveCar_Grey.png": 1360,
	"./Car/ExecutiveCar_Red.png": 1361,
	"./Car/ExecutiveCar_Yellow.png": 1362,
	"./Car/Hatchback_Black.png": 1363,
	"./Car/Hatchback_Blue.png": 1364,
	"./Car/Hatchback_Green.png": 1365,
	"./Car/Hatchback_Grey.png": 1366,
	"./Car/Hatchback_Red.png": 1367,
	"./Car/Hatchback_Yellow.png": 1368,
	"./Car/HybridCar_Black.png": 1369,
	"./Car/HybridCar_Blue.png": 1370,
	"./Car/HybridCar_Green.png": 1371,
	"./Car/HybridCar_Grey.png": 1372,
	"./Car/HybridCar_Red.png": 1373,
	"./Car/HybridCar_Yellow.png": 1374,
	"./Car/Jeep_Black.png": 1375,
	"./Car/Jeep_Blue.png": 1376,
	"./Car/Jeep_Green.png": 1377,
	"./Car/Jeep_Grey.png": 1378,
	"./Car/Jeep_Red.png": 1379,
	"./Car/Jeep_Yellow.png": 1380,
	"./Car/Limousine_Black.png": 1381,
	"./Car/Limousine_Blue.png": 1382,
	"./Car/Limousine_Green.png": 1383,
	"./Car/Limousine_Grey.png": 1384,
	"./Car/Limousine_Red.png": 1385,
	"./Car/Limousine_Yellow.png": 1386,
	"./Car/LuxuryCar__Black.png": 1387,
	"./Car/LuxuryCar__Blue.png": 1388,
	"./Car/LuxuryCar__Gray.png": 1389,
	"./Car/LuxuryCar__Green.png": 1390,
	"./Car/LuxuryCar__Red.png": 1391,
	"./Car/LuxuryCar__Yellow.png": 1392,
	"./Car/MUV_Black.png": 1393,
	"./Car/MUV_Blue.png": 1394,
	"./Car/MUV_Green.png": 1395,
	"./Car/MUV_Grey.png": 1396,
	"./Car/MUV_Red.png": 1397,
	"./Car/MUV_Yellow.png": 1398,
	"./Car/Minibus_Black.png": 1399,
	"./Car/Minibus_Blue.png": 1400,
	"./Car/Minibus_Green.png": 1401,
	"./Car/Minibus_Grey.png": 1402,
	"./Car/Minibus_Red.png": 1403,
	"./Car/Minibus_Yellow.png": 1404,
	"./Car/MinicarTrailer_Black.png": 1405,
	"./Car/MinicarTrailer_Blue.png": 1406,
	"./Car/MinicarTrailer_Green.png": 1407,
	"./Car/MinicarTrailer_Grey.png": 1408,
	"./Car/MinicarTrailer_Red.png": 1409,
	"./Car/MinicarTrailer_Yellow.png": 1410,
	"./Car/Minicar_Black.png": 1411,
	"./Car/Minicar_Blue.png": 1412,
	"./Car/Minicar_Green.png": 1413,
	"./Car/Minicar_Grey.png": 1414,
	"./Car/Minicar_Red.png": 1415,
	"./Car/Minicar_Yellow.png": 1416,
	"./Car/Minitruck_Black.png": 1417,
	"./Car/Minitruck_Blue.png": 1418,
	"./Car/Minitruck_Green.png": 1419,
	"./Car/Minitruck_Grey.png": 1420,
	"./Car/Minitruck_Red.png": 1421,
	"./Car/Minitruck_Yellow.png": 1422,
	"./Car/PanelVan_Black.png": 1423,
	"./Car/PanelVan_Blue.png": 1424,
	"./Car/PanelVan_Green.png": 1425,
	"./Car/PanelVan_Grey.png": 1426,
	"./Car/PanelVan_Red.png": 1427,
	"./Car/PanelVan_Yellow.png": 1428,
	"./Car/Pickup_Black.png": 1429,
	"./Car/Pickup_Blue.png": 1430,
	"./Car/Pickup_Green.png": 1431,
	"./Car/Pickup_Grey.png": 1432,
	"./Car/Pickup_Red.png": 1433,
	"./Car/Pickup_Yellow.png": 1434,
	"./Car/SUV_Black.png": 1435,
	"./Car/SUV_Blue.png": 1436,
	"./Car/SUV_Green.png": 1437,
	"./Car/SUV_Grey.png": 1438,
	"./Car/SUV_Red.png": 1439,
	"./Car/SUV_Yellow.png": 1440,
	"./Car/ServiceVan_Black.png": 1441,
	"./Car/ServiceVan_Blue.png": 1442,
	"./Car/ServiceVan_Green.png": 1443,
	"./Car/ServiceVan_Grey.png": 1444,
	"./Car/ServiceVan_Red.png": 1445,
	"./Car/ServiceVan_Yellow.png": 1446,
	"./Car/SportsCar_Black.png": 1447,
	"./Car/SportsCar_Blue.png": 1448,
	"./Car/SportsCar_Green.png": 1449,
	"./Car/SportsCar_Grey.png": 1450,
	"./Car/SportsCar_Red.png": 1451,
	"./Car/SportsCar_Yellow.png": 1452,
	"./Car/StationWagon_Black.png": 1453,
	"./Car/StationWagon_Blue.png": 1454,
	"./Car/StationWagon_Green.png": 1455,
	"./Car/StationWagon_Grey.png": 1456,
	"./Car/StationWagon_Red.png": 1457,
	"./Car/StationWagon_Yellow.png": 1458,
	"./Car/Van_Black.png": 1459,
	"./Car/Van_Blue.png": 1460,
	"./Car/Van_Green.png": 1461,
	"./Car/Van_Grey.png": 1462,
	"./Car/Van_Red.png": 1463,
	"./Car/Van_Yellow.png": 1464,
	"./Ecommerce/auction.png": 1465,
	"./Ecommerce/badge-1.png": 1466,
	"./Ecommerce/badge-2.png": 1467,
	"./Ecommerce/badge-3.png": 1468,
	"./Ecommerce/badge-4.png": 1469,
	"./Ecommerce/badge.png": 1470,
	"./Ecommerce/barcode.png": 1471,
	"./Ecommerce/bedside-table.png": 1472,
	"./Ecommerce/billing-machine.png": 1473,
	"./Ecommerce/browser-1.png": 1474,
	"./Ecommerce/browser.png": 1475,
	"./Ecommerce/calculator.png": 1476,
	"./Ecommerce/cash-register.png": 1477,
	"./Ecommerce/click.png": 1478,
	"./Ecommerce/clock.png": 1479,
	"./Ecommerce/closed.png": 1480,
	"./Ecommerce/coin-1.png": 1481,
	"./Ecommerce/coin-stack.png": 1482,
	"./Ecommerce/coin.png": 1483,
	"./Ecommerce/comments.png": 1484,
	"./Ecommerce/compact-disc.png": 1485,
	"./Ecommerce/cosmetics.png": 1486,
	"./Ecommerce/coupon.png": 1487,
	"./Ecommerce/credit-card-1.png": 1488,
	"./Ecommerce/credit-card-2.png": 1489,
	"./Ecommerce/credit-card.png": 1490,
	"./Ecommerce/customer-service.png": 1491,
	"./Ecommerce/delivery-cart.png": 1492,
	"./Ecommerce/delivery-truck-1.png": 1493,
	"./Ecommerce/delivery-truck.png": 1494,
	"./Ecommerce/diamond.png": 1495,
	"./Ecommerce/discount.png": 1496,
	"./Ecommerce/email.png": 1497,
	"./Ecommerce/faq.png": 1498,
	"./Ecommerce/gift-card.png": 1499,
	"./Ecommerce/gift.png": 1500,
	"./Ecommerce/groceries.png": 1501,
	"./Ecommerce/help.png": 1502,
	"./Ecommerce/like.png": 1503,
	"./Ecommerce/money-bag.png": 1504,
	"./Ecommerce/money.png": 1505,
	"./Ecommerce/monitor.png": 1506,
	"./Ecommerce/news.png": 1507,
	"./Ecommerce/notepad.png": 1508,
	"./Ecommerce/online-shop-1.png": 1509,
	"./Ecommerce/online-shop-2.png": 1510,
	"./Ecommerce/online-shop-3.png": 1511,
	"./Ecommerce/online-shop.png": 1512,
	"./Ecommerce/open.png": 1513,
	"./Ecommerce/order.png": 1514,
	"./Ecommerce/package-1.png": 1515,
	"./Ecommerce/package-2.png": 1516,
	"./Ecommerce/package-3.png": 1517,
	"./Ecommerce/package.png": 1518,
	"./Ecommerce/padlock.png": 1519,
	"./Ecommerce/piggy-bank.png": 1520,
	"./Ecommerce/placeholder.png": 1521,
	"./Ecommerce/price-tag.png": 1522,
	"./Ecommerce/promotion.png": 1523,
	"./Ecommerce/purse.png": 1524,
	"./Ecommerce/qr-code.png": 1525,
	"./Ecommerce/receipt.png": 1526,
	"./Ecommerce/refund.png": 1527,
	"./Ecommerce/return.png": 1528,
	"./Ecommerce/review.png": 1529,
	"./Ecommerce/rocket-ship.png": 1530,
	"./Ecommerce/safebox.png": 1531,
	"./Ecommerce/search-1.png": 1532,
	"./Ecommerce/search.png": 1533,
	"./Ecommerce/shield.png": 1534,
	"./Ecommerce/shirt-1.png": 1535,
	"./Ecommerce/shirt.png": 1536,
	"./Ecommerce/shopping-bag-1.png": 1537,
	"./Ecommerce/shopping-bag-2.png": 1538,
	"./Ecommerce/shopping-bag.png": 1539,
	"./Ecommerce/shopping-basket-1.png": 1540,
	"./Ecommerce/shopping-basket-2.png": 1541,
	"./Ecommerce/shopping-basket-3.png": 1542,
	"./Ecommerce/shopping-basket-4.png": 1543,
	"./Ecommerce/shopping-basket.png": 1544,
	"./Ecommerce/shopping-cart-1.png": 1545,
	"./Ecommerce/shopping-cart-2.png": 1546,
	"./Ecommerce/shopping-cart-3.png": 1547,
	"./Ecommerce/shopping-cart-4.png": 1548,
	"./Ecommerce/shopping-cart.png": 1549,
	"./Ecommerce/smartphone-1.png": 1550,
	"./Ecommerce/smartphone.png": 1551,
	"./Ecommerce/star.png": 1552,
	"./Ecommerce/statistics.png": 1553,
	"./Ecommerce/stock-1.png": 1554,
	"./Ecommerce/stock-2.png": 1555,
	"./Ecommerce/stock.png": 1556,
	"./Ecommerce/stopwatch.png": 1557,
	"./Ecommerce/store.png": 1558,
	"./Ecommerce/survey.png": 1559,
	"./Ecommerce/user.png": 1560,
	"./Ecommerce/wallet.png": 1561,
	"./Ecommerce/wishlist-1.png": 1562,
	"./Ecommerce/wishlist.png": 1563,
	"./Ecommerce/worldwide.png": 1564,
	"./Emergencies/001-air-pump.png": 1565,
	"./Emergencies/002-helicopter.png": 1566,
	"./Emergencies/003-defibrillator.png": 1567,
	"./Emergencies/004-toolbox.png": 1568,
	"./Emergencies/005-smartphone.png": 1569,
	"./Emergencies/006-heart.png": 1570,
	"./Emergencies/007-hospital-2.png": 1571,
	"./Emergencies/008-tools.png": 1572,
	"./Emergencies/009-caution.png": 1573,
	"./Emergencies/010-hospital-1.png": 1574,
	"./Emergencies/011-pin.png": 1575,
	"./Emergencies/012-blood-transfusion.png": 1576,
	"./Emergencies/013-firefighter-1.png": 1577,
	"./Emergencies/014-barrier.png": 1578,
	"./Emergencies/015-fire-truck.png": 1579,
	"./Emergencies/016-police-badge.png": 1580,
	"./Emergencies/017-hospital.png": 1581,
	"./Emergencies/018-bucket.png": 1582,
	"./Emergencies/019-smoke-detector.png": 1583,
	"./Emergencies/020-shovel.png": 1584,
	"./Emergencies/021-walkie-talkie.png": 1585,
	"./Emergencies/022-firefighter.png": 1586,
	"./Emergencies/023-stretcher.png": 1587,
	"./Emergencies/024-lifebuoy.png": 1588,
	"./Emergencies/025-fire-extinguisher.png": 1589,
	"./Emergencies/026-warning.png": 1590,
	"./Emergencies/027-hydrant.png": 1591,
	"./Emergencies/028-matches.png": 1592,
	"./Emergencies/029-phone-call.png": 1593,
	"./Emergencies/030-life-jacket.png": 1594,
	"./Emergencies/031-band-aid.png": 1595,
	"./Emergencies/032-lighter.png": 1596,
	"./Emergencies/033-megaphone.png": 1597,
	"./Emergencies/034-sos.png": 1598,
	"./Emergencies/035-whistle.png": 1599,
	"./Emergencies/036-flashlight.png": 1600,
	"./Emergencies/037-sprinkler.png": 1601,
	"./Emergencies/038-fire-alarm-1.png": 1602,
	"./Emergencies/039-gas-mask.png": 1603,
	"./Emergencies/040-ambulance.png": 1604,
	"./Emergencies/041-emergency-call.png": 1605,
	"./Emergencies/042-first-aid-kit.png": 1606,
	"./Emergencies/043-fire.png": 1607,
	"./Emergencies/044-hose.png": 1608,
	"./Emergencies/045-exit.png": 1609,
	"./Emergencies/046-axe.png": 1610,
	"./Emergencies/047-cone.png": 1611,
	"./Emergencies/048-ladder.png": 1612,
	"./Emergencies/049-siren.png": 1613,
	"./Emergencies/050-fire-alarm.png": 1614,
	"./Family/001-couple-3.png": 1615,
	"./Family/002-house.png": 1616,
	"./Family/003-stroller.png": 1617,
	"./Family/004-son.png": 1618,
	"./Family/005-suitcase.png": 1619,
	"./Family/006-family-2.png": 1620,
	"./Family/007-pet-house.png": 1621,
	"./Family/008-cups.png": 1622,
	"./Family/009-photo-album.png": 1623,
	"./Family/010-fireplace.png": 1624,
	"./Family/011-pin.png": 1625,
	"./Family/012-insurance.png": 1626,
	"./Family/013-swing.png": 1627,
	"./Family/014-sofa.png": 1628,
	"./Family/015-couple-2.png": 1629,
	"./Family/016-home-1.png": 1630,
	"./Family/017-daughter.png": 1631,
	"./Family/018-gift-1.png": 1632,
	"./Family/019-shopping-basket.png": 1633,
	"./Family/020-television.png": 1634,
	"./Family/021-divorce.png": 1635,
	"./Family/022-picture-1.png": 1636,
	"./Family/023-briefcase.png": 1637,
	"./Family/024-graduate.png": 1638,
	"./Family/025-pacifier.png": 1639,
	"./Family/026-beach-ball.png": 1640,
	"./Family/027-love.png": 1641,
	"./Family/028-couple-1.png": 1642,
	"./Family/029-couple.png": 1643,
	"./Family/030-scooter.png": 1644,
	"./Family/031-gift.png": 1645,
	"./Family/032-picture.png": 1646,
	"./Family/033-wedding-rings.png": 1647,
	"./Family/034-wedding-cake.png": 1648,
	"./Family/035-newlyweds.png": 1649,
	"./Family/036-grave.png": 1650,
	"./Family/037-crib.png": 1651,
	"./Family/038-cat.png": 1652,
	"./Family/039-father.png": 1653,
	"./Family/040-dog.png": 1654,
	"./Family/041-care.png": 1655,
	"./Family/042-family-1.png": 1656,
	"./Family/043-grandparents.png": 1657,
	"./Family/044-family.png": 1658,
	"./Family/045-home.png": 1659,
	"./Family/046-motherhood.png": 1660,
	"./Family/047-grandfather.png": 1661,
	"./Family/048-grandmother.png": 1662,
	"./Family/049-newborn.png": 1663,
	"./Family/050-mother.png": 1664,
	"./GPS/compass-1.png": 1665,
	"./GPS/compass.png": 1666,
	"./GPS/gps.png": 1667,
	"./GPS/location-1.png": 1668,
	"./GPS/location-2.png": 1669,
	"./GPS/location-3.png": 1670,
	"./GPS/location.png": 145,
	"./GPS/location3.png": 1671,
	"./GPS/location_green.svg": 303,
	"./GPS/locations.png": 1672,
	"./GPS/map-1.png": 1673,
	"./GPS/map-2.png": 1674,
	"./GPS/map-3.png": 1675,
	"./GPS/map.png": 1676,
	"./GPS/navigator.png": 1677,
	"./GPS/panel.png": 1678,
	"./GPS/pin.png": 1679,
	"./GPS/placeholder-1.png": 1680,
	"./GPS/placeholder-2.png": 1681,
	"./GPS/placeholder-3.png": 1682,
	"./GPS/placeholder-4.png": 1683,
	"./GPS/placeholder-5.png": 1684,
	"./GPS/placeholder-6.png": 1685,
	"./GPS/placeholder-7.png": 1686,
	"./GPS/placeholder.png": 63,
	"./GPS/push-pin.png": 1687,
	"./GPS/route-1.png": 1688,
	"./GPS/route.png": 1689,
	"./GPS/satellite.png": 1690,
	"./GPS/selectLocation.svg": 143,
	"./GPS/smartphone-1.png": 1691,
	"./GPS/smartphone.png": 1692,
	"./GPS/target.png": 1693,
	"./Home/alarm-clock.png": 1694,
	"./Home/alcoholic-1.png": 1695,
	"./Home/alcoholic.png": 1696,
	"./Home/bake.png": 1697,
	"./Home/bathing.png": 1698,
	"./Home/bedroom-1.png": 1699,
	"./Home/bedroom-2.png": 1700,
	"./Home/bedroom-3.png": 1701,
	"./Home/bedroom-4.png": 1702,
	"./Home/bedroom-5.png": 1703,
	"./Home/bedroom-6.png": 1704,
	"./Home/bedroom.png": 1705,
	"./Home/bookcase.png": 1706,
	"./Home/carpenter.png": 1707,
	"./Home/carpet.png": 1708,
	"./Home/chairs-1.png": 1709,
	"./Home/chairs-2.png": 1710,
	"./Home/chairs.png": 1711,
	"./Home/chinese-food.png": 1712,
	"./Home/coffee-cup-1.png": 1713,
	"./Home/coffee-cup-2.png": 1714,
	"./Home/coffee-shop.png": 1715,
	"./Home/coffees.png": 1716,
	"./Home/comfortable-1.png": 1717,
	"./Home/comfortable.png": 1718,
	"./Home/coolnes.png": 1719,
	"./Home/couch.png": 1720,
	"./Home/door-key.png": 1721,
	"./Home/drinking.png": 1722,
	"./Home/elegant.png": 1723,
	"./Home/firefighting.png": 1724,
	"./Home/fry.png": 1725,
	"./Home/game-console.png": 1726,
	"./Home/garbage-bin.png": 1727,
	"./Home/gardening.png": 1728,
	"./Home/hair-salon.png": 1729,
	"./Home/hangers.png": 1730,
	"./Home/home-repair.png": 1731,
	"./Home/hot-drink.png": 1732,
	"./Home/hygienic-1.png": 1733,
	"./Home/hygienic.png": 1734,
	"./Home/invention.png": 1735,
	"./Home/japanese-food.png": 1736,
	"./Home/kitchen-pack-1.png": 1737,
	"./Home/kitchen-pack-10.png": 1738,
	"./Home/kitchen-pack-11.png": 1739,
	"./Home/kitchen-pack-12.png": 1740,
	"./Home/kitchen-pack-13.png": 1741,
	"./Home/kitchen-pack-14.png": 1742,
	"./Home/kitchen-pack-15.png": 1743,
	"./Home/kitchen-pack-16.png": 1744,
	"./Home/kitchen-pack-2.png": 1745,
	"./Home/kitchen-pack-3.png": 1746,
	"./Home/kitchen-pack-4.png": 1747,
	"./Home/kitchen-pack-5.png": 1748,
	"./Home/kitchen-pack-6.png": 1749,
	"./Home/kitchen-pack-7.png": 1750,
	"./Home/kitchen-pack-8.png": 1751,
	"./Home/kitchen-pack-9.png": 1752,
	"./Home/kitchen-pack.png": 1753,
	"./Home/kitchen-tools.png": 1754,
	"./Home/laptop-computer.png": 1755,
	"./Home/livingroom-1.png": 1756,
	"./Home/livingroom-2.png": 1757,
	"./Home/livingroom.png": 1758,
	"./Home/passkey.png": 1759,
	"./Home/phone-call.png": 1760,
	"./Home/phone-receiver.png": 1761,
	"./Home/plugging-1.png": 1762,
	"./Home/plugging.png": 1763,
	"./Home/protein.png": 1764,
	"./Home/real-estate-1.png": 1765,
	"./Home/real-estate-2.png": 1766,
	"./Home/real-estate-3.png": 1767,
	"./Home/real-estate.png": 1768,
	"./Home/reflecting.png": 1769,
	"./Home/refreshment.png": 1770,
	"./Home/restauran.png": 1771,
	"./Home/restroom.png": 1772,
	"./Home/seat.png": 1773,
	"./Home/seatting.png": 1774,
	"./Home/showers.png": 1775,
	"./Home/sinks.png": 1776,
	"./Home/sleepy.png": 1777,
	"./Home/studying-1.png": 1778,
	"./Home/studying-2.png": 1779,
	"./Home/studying.png": 1780,
	"./Home/supper.png": 1781,
	"./Home/technological.png": 1782,
	"./Home/televisions-1.png": 1783,
	"./Home/televisions.png": 1784,
	"./Home/ventilator.png": 1785,
	"./Home/wooden-chair.png": 1786,
	"./Home/yard.png": 1787,
	"./Hospital/ambulance.png": 1788,
	"./Hospital/band-aid.png": 1789,
	"./Hospital/bandage.png": 1790,
	"./Hospital/blood-donation.png": 1791,
	"./Hospital/blood-sample.png": 1792,
	"./Hospital/blood-transfusion.png": 1793,
	"./Hospital/broken-bone.png": 1794,
	"./Hospital/cardiogram.png": 1795,
	"./Hospital/clinic-history.png": 1796,
	"./Hospital/coffee-cup.png": 1797,
	"./Hospital/crutches.png": 1798,
	"./Hospital/dna.png": 1799,
	"./Hospital/doctor.png": 1800,
	"./Hospital/dropper.png": 1801,
	"./Hospital/electrocardiogram.png": 1802,
	"./Hospital/eye-drops.png": 1803,
	"./Hospital/eye.png": 1804,
	"./Hospital/first-aid-kit.png": 1805,
	"./Hospital/flask.png": 1806,
	"./Hospital/hospital-1.png": 1807,
	"./Hospital/hospital-2.png": 1808,
	"./Hospital/hospital-bed.png": 1809,
	"./Hospital/hospital.png": 1810,
	"./Hospital/id-card.png": 1811,
	"./Hospital/laptop.png": 1812,
	"./Hospital/mask.png": 1813,
	"./Hospital/medicine-1.png": 1814,
	"./Hospital/medicine-2.png": 1815,
	"./Hospital/medicine-3.png": 1816,
	"./Hospital/medicine-4.png": 1817,
	"./Hospital/medicine.png": 1818,
	"./Hospital/microscope.png": 1819,
	"./Hospital/nurse.png": 1820,
	"./Hospital/optometry.png": 1821,
	"./Hospital/pill.png": 1822,
	"./Hospital/pills-1.png": 1823,
	"./Hospital/pills.png": 1824,
	"./Hospital/placeholder.png": 1825,
	"./Hospital/prescription.png": 1826,
	"./Hospital/serum.png": 1827,
	"./Hospital/shirt.png": 1828,
	"./Hospital/smartphone.png": 1829,
	"./Hospital/stethoscope.png": 1830,
	"./Hospital/tag.png": 1831,
	"./Hospital/test-tube.png": 1832,
	"./Hospital/thermometer.png": 1833,
	"./Hospital/tooth.png": 1834,
	"./Hospital/vaccine.png": 1835,
	"./Hospital/virus.png": 1836,
	"./Hospital/weight.png": 1837,
	"./Lights/amber_light.png": 1838,
	"./Lights/green_light.png": 1839,
	"./Lights/grey_light.png": 1840,
	"./Lights/red_light.png": 1841,
	"./Lights/traffic_light_green.png": 1842,
	"./Lights/traffic_light_none.png": 1843,
	"./Lights/traffic_light_red.png": 1844,
	"./Lights/trafficlight.png": 1845,
	"./Lights/trafficlightcolour.png": 1846,
	"./Logistics/001-distribution-5.png": 1847,
	"./Logistics/002-aerial.png": 1848,
	"./Logistics/003-frontal-view.png": 1849,
	"./Logistics/004-distribution-4.png": 1850,
	"./Logistics/005-clipboards.png": 1851,
	"./Logistics/006-oceanic.png": 1852,
	"./Logistics/007-placeholders-1.png": 1853,
	"./Logistics/008-international.png": 1854,
	"./Logistics/009-packages-2.png": 1855,
	"./Logistics/010-tools-and-utensils-3.png": 1856,
	"./Logistics/011-weekly-calendar.png": 1857,
	"./Logistics/012-placeholders.png": 1858,
	"./Logistics/013-distribution-3.png": 1859,
	"./Logistics/014-shopping-carts-1.png": 1860,
	"./Logistics/015-maps-and-flags-1.png": 1861,
	"./Logistics/016-organizing.png": 1862,
	"./Logistics/017-maps-and-flags.png": 1863,
	"./Logistics/018-tools-and-utensils-2.png": 1864,
	"./Logistics/019-call-center-1.png": 1865,
	"./Logistics/020-protected.png": 1866,
	"./Logistics/021-cubes.png": 1867,
	"./Logistics/022-distribution-2.png": 1868,
	"./Logistics/023-call-center.png": 1869,
	"./Logistics/024-bussiness.png": 1870,
	"./Logistics/025-charter.png": 1871,
	"./Logistics/026-trolley-cart.png": 1872,
	"./Logistics/027-distribution-1.png": 1873,
	"./Logistics/028-tools-and-utensils-1.png": 1874,
	"./Logistics/029-airplanes.png": 1875,
	"./Logistics/030-verified.png": 1876,
	"./Logistics/031-shopping-carts.png": 1877,
	"./Logistics/032-transportation.png": 1878,
	"./Logistics/033-packages-1.png": 1879,
	"./Logistics/034-changing.png": 1880,
	"./Logistics/035-packages.png": 1881,
	"./Logistics/036-symbolic.png": 1882,
	"./Logistics/037-packing.png": 1883,
	"./Logistics/038-trucks.png": 1884,
	"./Logistics/039-tools-and-utensils.png": 1885,
	"./Logistics/040-circular-arrows.png": 1886,
	"./Logistics/041-debit-card.png": 1887,
	"./Logistics/042-24-hours.png": 1888,
	"./Logistics/043-distribution.png": 1889,
	"./Logistics/044-cargo-ship.png": 1890,
	"./Machinery/BackhoeLoader_Black.png": 1891,
	"./Machinery/BackhoeLoader_Blue.png": 1892,
	"./Machinery/BackhoeLoader_Green.png": 1893,
	"./Machinery/BackhoeLoader_Grey.png": 1894,
	"./Machinery/BackhoeLoader_Red.png": 1895,
	"./Machinery/BackhoeLoader_Yellow.png": 1896,
	"./Machinery/Bulldozer_Black.png": 1897,
	"./Machinery/Bulldozer_Blue.png": 1898,
	"./Machinery/Bulldozer_Green.png": 1899,
	"./Machinery/Bulldozer_Grey.png": 1900,
	"./Machinery/Bulldozer_Red.png": 1901,
	"./Machinery/Bulldozer_Yellow.png": 1902,
	"./Machinery/CompactExcavator_Black.png": 1903,
	"./Machinery/CompactExcavator_Blue.png": 1904,
	"./Machinery/CompactExcavator_Green.png": 1905,
	"./Machinery/CompactExcavator_Grey.png": 1906,
	"./Machinery/CompactExcavator_Red.png": 1907,
	"./Machinery/CompactExcavator_Yellow.png": 1908,
	"./Machinery/Excavator_Black.png": 1909,
	"./Machinery/Excavator_Blue.png": 1910,
	"./Machinery/Excavator_Green.png": 1911,
	"./Machinery/Excavator_Grey.png": 1912,
	"./Machinery/Excavator_Red.png": 1913,
	"./Machinery/Excavator_Yellow.png": 1914,
	"./Machinery/FarmTractor_Black.png": 1915,
	"./Machinery/FarmTractor_Blue.png": 1916,
	"./Machinery/FarmTractor_Green.png": 1917,
	"./Machinery/FarmTractor_Grey.png": 1918,
	"./Machinery/FarmTractor_Red.png": 1919,
	"./Machinery/FarmTractor_Yellow.png": 1920,
	"./Machinery/ForkliftTruck_Loaded_Black.png": 1921,
	"./Machinery/ForkliftTruck_Loaded_Blue.png": 1922,
	"./Machinery/ForkliftTruck_Loaded_Green.png": 1923,
	"./Machinery/ForkliftTruck_Loaded_Grey.png": 1924,
	"./Machinery/ForkliftTruck_Loaded_Red.png": 1925,
	"./Machinery/ForkliftTruck_Loaded_Yellow.png": 1926,
	"./Machinery/ForkliftTruck__Black.png": 1927,
	"./Machinery/ForkliftTruck__Blue.png": 1928,
	"./Machinery/ForkliftTruck__Green.png": 1929,
	"./Machinery/ForkliftTruck__Grey.png": 1930,
	"./Machinery/ForkliftTruck__Red.png": 1931,
	"./Machinery/ForkliftTruck__Yellow.png": 1932,
	"./Machinery/LandfillCompactor_Black.png": 1933,
	"./Machinery/LandfillCompactor_Blue.png": 1934,
	"./Machinery/LandfillCompactor_Green.png": 1935,
	"./Machinery/LandfillCompactor_Grey.png": 1936,
	"./Machinery/LandfillCompactor_Red.png": 1937,
	"./Machinery/LandfillCompactor_Yellow.png": 1938,
	"./Machinery/Loader_Black.png": 1939,
	"./Machinery/Loader_Blue.png": 1940,
	"./Machinery/Loader_Green.png": 1941,
	"./Machinery/Loader_Grey.png": 1942,
	"./Machinery/Loader_Red.png": 1943,
	"./Machinery/Loader_Yellow.png": 1944,
	"./Machinery/MaterialHandler_Black.png": 1945,
	"./Machinery/MaterialHandler_Blue.png": 1946,
	"./Machinery/MaterialHandler_Green.png": 1947,
	"./Machinery/MaterialHandler_Grey.png": 1948,
	"./Machinery/MaterialHandler_Red.png": 1949,
	"./Machinery/MaterialHandler_Yellow.png": 1950,
	"./Machinery/RoadRoller_Black.png": 1951,
	"./Machinery/RoadRoller_Blue.png": 1952,
	"./Machinery/RoadRoller_Green.png": 1953,
	"./Machinery/RoadRoller_Grey.png": 1954,
	"./Machinery/RoadRoller_Red.png": 1955,
	"./Machinery/RoadRoller_Yellow.png": 1956,
	"./Machinery/RoadSweeper_Black.png": 1957,
	"./Machinery/RoadSweeper_Blue.png": 1958,
	"./Machinery/RoadSweeper_Green.png": 1959,
	"./Machinery/RoadSweeper_Grey.png": 1960,
	"./Machinery/RoadSweeper_Red.png": 1961,
	"./Machinery/RoadSweeper_Yellow.png": 1962,
	"./Machinery/RollerCompactor_Black.png": 1963,
	"./Machinery/RollerCompactor_Blue.png": 1964,
	"./Machinery/RollerCompactor_Green.png": 1965,
	"./Machinery/RollerCompactor_Grey.png": 1966,
	"./Machinery/RollerCompactor_Red.png": 1967,
	"./Machinery/RollerCompactor_Yellow.png": 1968,
	"./Machinery/SkidSteerLoader_Black.png": 1969,
	"./Machinery/SkidSteerLoader_Blue.png": 1970,
	"./Machinery/SkidSteerLoader_Green.png": 1971,
	"./Machinery/SkidSteerLoader_Grey.png": 1972,
	"./Machinery/SkidSteerLoader_Red.png": 1973,
	"./Machinery/SkidSteerLoader_Yellow.png": 1974,
	"./Machinery/SkipLoader_Black.png": 1975,
	"./Machinery/SkipLoader_Blue.png": 1976,
	"./Machinery/SkipLoader_Green.png": 1977,
	"./Machinery/SkipLoader_Grey.png": 1978,
	"./Machinery/SkipLoader_Red.png": 1979,
	"./Machinery/SkipLoader_Yellow.png": 1980,
	"./Machinery/SoilStabilizer_Black.png": 1981,
	"./Machinery/SoilStabilizer_Blue.png": 1982,
	"./Machinery/SoilStabilizer_Green.png": 1983,
	"./Machinery/SoilStabilizer_Grey.png": 1984,
	"./Machinery/SoilStabilizer_Red.png": 1985,
	"./Machinery/SoilStabilizer_Yellow.png": 1986,
	"./Machinery/SteamRoller_Black.png": 1987,
	"./Machinery/SteamRoller_Blue.png": 1988,
	"./Machinery/SteamRoller_Green.png": 1989,
	"./Machinery/SteamRoller_Grey.png": 1990,
	"./Machinery/SteamRoller_Red.png": 1991,
	"./Machinery/SteamRoller_Yellow.png": 1992,
	"./Machinery/StreetSweeper_Black.png": 1993,
	"./Machinery/StreetSweeper_Blue.png": 1994,
	"./Machinery/StreetSweeper_Green.png": 1995,
	"./Machinery/StreetSweeper_Grey.png": 1996,
	"./Machinery/StreetSweeper_Red.png": 1997,
	"./Machinery/StreetSweeper_Yellow.png": 1998,
	"./Machinery/TelescopicHandler_Black.png": 1999,
	"./Machinery/TelescopicHandler_Blue.png": 2000,
	"./Machinery/TelescopicHandler_Green.png": 2001,
	"./Machinery/TelescopicHandler_Grey.png": 2002,
	"./Machinery/TelescopicHandler_Red.png": 2003,
	"./Machinery/TelescopicHandler_Yellow.png": 2004,
	"./Machinery/TruckMountedCrane_Working_Black.png": 2005,
	"./Machinery/TruckMountedCrane_Working_Blue.png": 2006,
	"./Machinery/TruckMountedCrane_Working_Green.png": 2007,
	"./Machinery/TruckMountedCrane_Working_Grey.png": 2008,
	"./Machinery/TruckMountedCrane_Working_Red.png": 2009,
	"./Machinery/TruckMountedCrane_Working_Yellow.png": 2010,
	"./Machinery/TruckMountedCrane__Black.png": 2011,
	"./Machinery/TruckMountedCrane__Blue.png": 2012,
	"./Machinery/TruckMountedCrane__Green.png": 2013,
	"./Machinery/TruckMountedCrane__Grey.png": 2014,
	"./Machinery/TruckMountedCrane__Red.png": 2015,
	"./Machinery/TruckMountedCrane__Yellow.png": 2016,
	"./Machinery/WheeledExcavator_Black.png": 2017,
	"./Machinery/WheeledExcavator_Blue.png": 2018,
	"./Machinery/WheeledExcavator_Green.png": 2019,
	"./Machinery/WheeledExcavator_Grey.png": 2020,
	"./Machinery/WheeledExcavator_Red.png": 2021,
	"./Machinery/WheeledExcavator_Yellow.png": 2022,
	"./Machinery/WreckingBall_Black.png": 2023,
	"./Machinery/WreckingBall_Blue.png": 2024,
	"./Machinery/WreckingBall_Green.png": 2025,
	"./Machinery/WreckingBall_Grey.png": 2026,
	"./Machinery/WreckingBall_Red.png": 2027,
	"./Machinery/WreckingBall_Yellow.png": 2028,
	"./Marine/001-pirate-3.png": 2029,
	"./Marine/001-whale.png": 2030,
	"./Marine/002-hook.png": 2031,
	"./Marine/002-lifesaver.png": 2032,
	"./Marine/003-round-shot.png": 2033,
	"./Marine/003-sailor-cap-2.png": 2034,
	"./Marine/004-anchor-2.png": 2035,
	"./Marine/004-starfish.png": 2036,
	"./Marine/005-anchor-1.png": 2037,
	"./Marine/005-cannon.png": 2038,
	"./Marine/006-dolphin.png": 2039,
	"./Marine/006-parrot.png": 2040,
	"./Marine/007-island.png": 2041,
	"./Marine/007-knot-1.png": 2042,
	"./Marine/008-pirate-2.png": 2043,
	"./Marine/008-sailor-cap-1.png": 2044,
	"./Marine/009-flag.png": 2045,
	"./Marine/009-key.png": 2046,
	"./Marine/010-barrel.png": 2047,
	"./Marine/010-seagull-1.png": 2048,
	"./Marine/011-boat.png": 2049,
	"./Marine/011-paddle.png": 2050,
	"./Marine/012-pirate-ship.png": 2051,
	"./Marine/012-porthole.png": 2052,
	"./Marine/013-bollard.png": 2053,
	"./Marine/013-gold-ingots.png": 2054,
	"./Marine/014-lighthouse-1.png": 2055,
	"./Marine/014-placeholder.png": 2056,
	"./Marine/015-buoys.png": 2057,
	"./Marine/015-skull-and-bones.png": 2058,
	"./Marine/016-flippers.png": 2059,
	"./Marine/016-sword.png": 2060,
	"./Marine/017-pirate-1.png": 2061,
	"./Marine/017-shirt.png": 2062,
	"./Marine/018-chains.png": 2063,
	"./Marine/018-pipe.png": 2064,
	"./Marine/019-eyepatch.png": 2065,
	"./Marine/019-pipe-1.png": 2066,
	"./Marine/020-compass-2.png": 2067,
	"./Marine/020-gallows.png": 2068,
	"./Marine/021-coin.png": 2069,
	"./Marine/021-radar-1.png": 2070,
	"./Marine/022-compass-1.png": 2071,
	"./Marine/022-rum.png": 2072,
	"./Marine/023-money-bag.png": 2073,
	"./Marine/023-radar.png": 2074,
	"./Marine/024-diving-helmet.png": 2075,
	"./Marine/024-pirate.png": 2076,
	"./Marine/025-bottle.png": 2077,
	"./Marine/025-treasure-map.png": 2078,
	"./Marine/026-captain.png": 2079,
	"./Marine/026-wooden-leg.png": 2080,
	"./Marine/027-helm.png": 2081,
	"./Marine/027-yatch.png": 2082,
	"./Marine/028-message-in-a-bottle.png": 2083,
	"./Marine/028-oars.png": 2084,
	"./Marine/029-lighthouse.png": 2085,
	"./Marine/029-ship.png": 2086,
	"./Marine/030-binoculars.png": 2087,
	"./Marine/030-torch.png": 2088,
	"./Marine/031-jolly-roger.png": 2089,
	"./Marine/031-propeller.png": 2090,
	"./Marine/032-bell.png": 2091,
	"./Marine/032-hook.png": 2092,
	"./Marine/033-dice.png": 2093,
	"./Marine/033-map.png": 2094,
	"./Marine/034-sailor-cap.png": 2095,
	"./Marine/034-telescope.png": 2096,
	"./Marine/035-knot.png": 2097,
	"./Marine/035-tortoise.png": 2098,
	"./Marine/036-letter.png": 2099,
	"./Marine/036-waves.png": 2100,
	"./Marine/037-anchor.png": 2101,
	"./Marine/037-pipe.png": 2102,
	"./Marine/038-compass.png": 2103,
	"./Marine/038-lifebuoy.png": 2104,
	"./Marine/039-bomb.png": 2105,
	"./Marine/039-rudder-1.png": 2106,
	"./Marine/040-sailboat.png": 2107,
	"./Marine/040-treasure.png": 2108,
	"./Marine/041-starfish.png": 2109,
	"./Marine/042-lighthouse.png": 2110,
	"./Marine/043-spyglass.png": 2111,
	"./Marine/044-fish.png": 2112,
	"./Marine/045-compass.png": 2113,
	"./Marine/046-anchor.png": 2114,
	"./Marine/047-seagull.png": 2115,
	"./Marine/048-rudder.png": 2116,
	"./Marine/049-snorkel.png": 2117,
	"./Marine/050-life-jacket.png": 2118,
	"./Military/001-knife.png": 2119,
	"./Military/002-bomb-1.png": 2120,
	"./Military/003-radar.png": 2121,
	"./Military/004-medal-1.png": 2122,
	"./Military/005-launcher-1.png": 2123,
	"./Military/006-helmet.png": 2124,
	"./Military/007-chamber.png": 2125,
	"./Military/008-helicopter.png": 2126,
	"./Military/009-soldier.png": 2127,
	"./Military/010-lieutenant.png": 2128,
	"./Military/011-shotgun.png": 2129,
	"./Military/012-backpack.png": 2130,
	"./Military/013-bomb-detonation-1.png": 2131,
	"./Military/014-bomb-detonation.png": 2132,
	"./Military/015-fighter-plane.png": 2133,
	"./Military/016-dynamite.png": 2134,
	"./Military/017-first-aid-kit-1.png": 2135,
	"./Military/018-boat.png": 2136,
	"./Military/019-submarine.png": 2137,
	"./Military/020-compass.png": 2138,
	"./Military/021-insignia.png": 2139,
	"./Military/022-first-aid-kit.png": 2140,
	"./Military/023-placeholder.png": 2141,
	"./Military/024-jet.png": 2142,
	"./Military/025-flag.png": 2143,
	"./Military/026-boots.png": 2144,
	"./Military/027-gas-mask.png": 2145,
	"./Military/028-bullet-1.png": 2146,
	"./Military/029-launcher.png": 2147,
	"./Military/030-satellite-dish.png": 2148,
	"./Military/031-parachute.png": 2149,
	"./Military/032-gun.png": 2150,
	"./Military/033-bulletproof.png": 2151,
	"./Military/034-swiss-army-knife.png": 2152,
	"./Military/035-bullet.png": 2153,
	"./Military/036-binoculars.png": 2154,
	"./Military/037-target.png": 2155,
	"./Military/038-walkie-talkie.png": 2156,
	"./Military/039-rank.png": 2157,
	"./Military/040-barbed.png": 2158,
	"./Military/041-bomb.png": 2159,
	"./Military/042-radiation.png": 2160,
	"./Military/043-chevron.png": 2161,
	"./Military/044-map.png": 2162,
	"./Military/045-medal.png": 2163,
	"./Military/046-tank.png": 2164,
	"./Military/047-tent.png": 2165,
	"./Military/048-dog-tags-military.png": 2166,
	"./Military/049-grenade.png": 2167,
	"./Military/050-badge.png": 2168,
	"./Multimedia/3d-glasses.png": 2169,
	"./Multimedia/antenna.png": 2170,
	"./Multimedia/camera-1.png": 2171,
	"./Multimedia/camera-2.png": 2172,
	"./Multimedia/camera-3.png": 2173,
	"./Multimedia/camera.png": 2174,
	"./Multimedia/cd.png": 2175,
	"./Multimedia/chat.png": 2176,
	"./Multimedia/clapperboard.png": 2177,
	"./Multimedia/cloud.png": 2178,
	"./Multimedia/compact-disc.png": 2179,
	"./Multimedia/dvd.png": 2180,
	"./Multimedia/equalizer.png": 2181,
	"./Multimedia/film.png": 2182,
	"./Multimedia/floppy-disk.png": 2183,
	"./Multimedia/game.png": 2184,
	"./Multimedia/ipod-shuffle.png": 2185,
	"./Multimedia/ipod.png": 2186,
	"./Multimedia/keyboard.png": 2187,
	"./Multimedia/loudspeaker-1.png": 2188,
	"./Multimedia/loudspeaker.png": 2189,
	"./Multimedia/memory-card.png": 2190,
	"./Multimedia/microphone-1.png": 2191,
	"./Multimedia/microphone.png": 2192,
	"./Multimedia/mobile-phone.png": 2193,
	"./Multimedia/modem.png": 2194,
	"./Multimedia/negative-film.png": 2195,
	"./Multimedia/negative.png": 2196,
	"./Multimedia/next-track.png": 2197,
	"./Multimedia/pause.png": 2198,
	"./Multimedia/photos.png": 2199,
	"./Multimedia/play.png": 2200,
	"./Multimedia/previous-track.png": 2201,
	"./Multimedia/radio.png": 2202,
	"./Multimedia/rec.png": 2203,
	"./Multimedia/speaker.png": 2204,
	"./Multimedia/stop.png": 2205,
	"./Multimedia/tablet.png": 2206,
	"./Multimedia/tv-1.png": 2207,
	"./Multimedia/tv.png": 2208,
	"./Multimedia/web-cam.png": 2209,
	"./Office/adhesive-tape.png": 2210,
	"./Office/bookshelf.png": 2211,
	"./Office/box.png": 2212,
	"./Office/briefcase.png": 2213,
	"./Office/business-card.png": 2214,
	"./Office/cabinet.png": 2215,
	"./Office/calculator.png": 2216,
	"./Office/calendar.png": 2217,
	"./Office/clipboard.png": 2218,
	"./Office/clock.png": 2219,
	"./Office/coffee-cup.png": 2220,
	"./Office/computer.png": 2221,
	"./Office/copy-machine.png": 2222,
	"./Office/documents.png": 2223,
	"./Office/fax.png": 2224,
	"./Office/folder-1.png": 2225,
	"./Office/folder-2.png": 2226,
	"./Office/folder.png": 2227,
	"./Office/garbage.png": 2228,
	"./Office/headphones.png": 2229,
	"./Office/highlighter.png": 2230,
	"./Office/hole-puncher.png": 2231,
	"./Office/id-card.png": 2232,
	"./Office/lamp.png": 2233,
	"./Office/laptop.png": 2234,
	"./Office/letters.png": 2235,
	"./Office/mail.png": 2236,
	"./Office/mouse.png": 2237,
	"./Office/mug.png": 2238,
	"./Office/note.png": 2239,
	"./Office/notebook-1.png": 2240,
	"./Office/notebook.png": 2241,
	"./Office/office-chair.png": 2242,
	"./Office/paper-shredder.png": 2243,
	"./Office/pen.png": 2244,
	"./Office/pencil-case.png": 2245,
	"./Office/pendrive.png": 2246,
	"./Office/plant.png": 2247,
	"./Office/presentation.png": 2248,
	"./Office/printer.png": 2249,
	"./Office/projector.png": 2250,
	"./Office/push-pin.png": 2251,
	"./Office/router.png": 2252,
	"./Office/rubber-stamp.png": 2253,
	"./Office/safebox.png": 2254,
	"./Office/stapler.png": 2255,
	"./Office/table.png": 2256,
	"./Office/telephone.png": 2257,
	"./Office/uniform.png": 2258,
	"./Office/webcam.png": 2259,
	"./Professions/astronaut.png": 2260,
	"./Professions/athlete.png": 2261,
	"./Professions/builder.png": 2262,
	"./Professions/carpenter.png": 2263,
	"./Professions/cashier.png": 2264,
	"./Professions/chef.png": 2265,
	"./Professions/chemist.png": 2266,
	"./Professions/clown.png": 2267,
	"./Professions/concierge.png": 2268,
	"./Professions/courier.png": 2269,
	"./Professions/detective.png": 2270,
	"./Professions/diver.png": 2271,
	"./Professions/dj.png": 2272,
	"./Professions/doctor.png": 2273,
	"./Professions/dyer.png": 2274,
	"./Professions/electrician.png": 2275,
	"./Professions/farmer.png": 2276,
	"./Professions/firefighter.png": 2277,
	"./Professions/fisherman.png": 2278,
	"./Professions/gardener.png": 2279,
	"./Professions/hairdresser.png": 2280,
	"./Professions/lumberjack.png": 2281,
	"./Professions/magician.png": 2282,
	"./Professions/maid.png": 2283,
	"./Professions/manager.png": 2284,
	"./Professions/mechanic.png": 2285,
	"./Professions/miner.png": 2286,
	"./Professions/nurse.png": 2287,
	"./Professions/painter.png": 2288,
	"./Professions/pensioner.png": 2289,
	"./Professions/personplaceholder.png": 218,
	"./Professions/photographer.png": 2290,
	"./Professions/pilot.png": 2291,
	"./Professions/plumber.png": 2292,
	"./Professions/policeman.png": 2293,
	"./Professions/politician.png": 2294,
	"./Professions/postman.png": 2295,
	"./Professions/priest.png": 2296,
	"./Professions/professor.png": 2297,
	"./Professions/programmer.png": 2298,
	"./Professions/sailor.png": 2299,
	"./Professions/secretary.png": 2300,
	"./Professions/showman.png": 2301,
	"./Professions/singer.png": 2302,
	"./Professions/soldier.png": 2303,
	"./Professions/stewardess.png": 2304,
	"./Professions/support.png": 2305,
	"./Professions/taxi-driver.png": 2306,
	"./Professions/teacher.png": 2307,
	"./Professions/waiter.png": 2308,
	"./Professions/writer.png": 2309,
	"./PublicTransport/Coach_Black.png": 2310,
	"./PublicTransport/Coach_Blue.png": 2311,
	"./PublicTransport/Coach_Green.png": 2312,
	"./PublicTransport/Coach_Grey.png": 2313,
	"./PublicTransport/Coach_Red.png": 2314,
	"./PublicTransport/Coach_Yellow.png": 2315,
	"./PublicTransport/CommuterBus_Black.png": 2316,
	"./PublicTransport/CommuterBus_Blue.png": 2317,
	"./PublicTransport/CommuterBus_Green.png": 2318,
	"./PublicTransport/CommuterBus_Grey.png": 2319,
	"./PublicTransport/CommuterBus_Red.png": 2320,
	"./PublicTransport/CommuterBus_Yellow.png": 2321,
	"./PublicTransport/Taxi_Black.png": 2322,
	"./PublicTransport/Taxi_Blue.png": 2323,
	"./PublicTransport/Taxi_Green.png": 2324,
	"./PublicTransport/Taxi_Grey.png": 2325,
	"./PublicTransport/Taxi_Red.png": 2326,
	"./PublicTransport/Taxi_Yellow.png": 2327,
	"./PublicTransport/TransitBus_Black.png": 2328,
	"./PublicTransport/TransitBus_Blue.png": 2329,
	"./PublicTransport/TransitBus_Green.png": 2330,
	"./PublicTransport/TransitBus_Grey.png": 2331,
	"./PublicTransport/TransitBus_Red.png": 2332,
	"./PublicTransport/TransitBus_Yellow.png": 2333,
	"./Safety/001-fire.png": 2334,
	"./Safety/002-umbrella.png": 2335,
	"./Safety/003-shield-1.png": 2336,
	"./Safety/004-lifebuoy.png": 2337,
	"./Safety/005-cone.png": 2338,
	"./Safety/006-eye.png": 2339,
	"./Safety/007-helmet.png": 2340,
	"./Safety/008-safety-belt.png": 2341,
	"./Safety/009-first-aid-kit.png": 2342,
	"./Safety/010-barbed-wire.png": 2343,
	"./Safety/011-shield.png": 2344,
	"./Safety/012-cctv-1.png": 2345,
	"./Safety/013-cctv.png": 2346,
	"./Safety/014-fire-alarm-1.png": 2347,
	"./Safety/015-hose.png": 2348,
	"./Safety/016-hydrant.png": 2349,
	"./Safety/017-flasher.png": 2350,
	"./Safety/018-kitchen-hood.png": 2351,
	"./Safety/019-air-compressor.png": 2352,
	"./Safety/020-gas-mask.png": 2353,
	"./Safety/021-carbon-monoxide.png": 2354,
	"./Safety/022-extinguisher.png": 2355,
	"./Safety/023-sprinkler.png": 2356,
	"./Safety/024-pull.png": 2357,
	"./Safety/025-fire-alarm.png": 2358,
	"./Safety/026-smoke-detector.png": 2359,
	"./Safety/027-safety-code.png": 2360,
	"./Safety/028-signal.png": 2361,
	"./Safety/029-strongbox.png": 2362,
	"./Safety/030-password.png": 2363,
	"./Safety/031-key.png": 2364,
	"./Safety/032-keyhole.png": 2365,
	"./Safety/033-exit-1.png": 2366,
	"./Safety/034-door.png": 2367,
	"./Safety/035-padlock-1.png": 2368,
	"./Safety/036-padlock.png": 2369,
	"./Safety/037-house.png": 2370,
	"./Safety/038-exit.png": 2371,
	"./Safety/039-bell.png": 2372,
	"./Safety/040-stop.png": 2373,
	"./Safety/041-radiation.png": 2374,
	"./Safety/042-forbidden.png": 2375,
	"./Safety/043-not-touch.png": 2376,
	"./Safety/044-no-smoking.png": 2377,
	"./Safety/045-no-fire.png": 2378,
	"./Safety/046-high-voltage.png": 2379,
	"./Safety/047-fire-sign.png": 2380,
	"./Safety/048-warning.png": 2381,
	"./Safety/049-bomb.png": 2382,
	"./Safety/050-antenna.png": 2383,
	"./Shipping/aeroplane.png": 2384,
	"./Shipping/barcode.png": 2385,
	"./Shipping/box-1.png": 2386,
	"./Shipping/box.png": 2387,
	"./Shipping/boxes.png": 2388,
	"./Shipping/calendar.png": 2389,
	"./Shipping/clipboard.png": 2390,
	"./Shipping/container.png": 2391,
	"./Shipping/delivery-1.png": 2392,
	"./Shipping/delivery-2.png": 2393,
	"./Shipping/delivery-3.png": 2394,
	"./Shipping/delivery-truck.png": 2395,
	"./Shipping/delivery.png": 2396,
	"./Shipping/envelope.png": 2397,
	"./Shipping/find.png": 2398,
	"./Shipping/fragile.png": 2399,
	"./Shipping/gift.png": 2400,
	"./Shipping/laptop.png": 2401,
	"./Shipping/package-1.png": 2402,
	"./Shipping/package-2.png": 2403,
	"./Shipping/package-3.png": 2404,
	"./Shipping/package-4.png": 2405,
	"./Shipping/package-5.png": 2406,
	"./Shipping/package-6.png": 2407,
	"./Shipping/package-7.png": 2408,
	"./Shipping/package.png": 2409,
	"./Shipping/route.png": 2410,
	"./Shipping/safety.png": 2411,
	"./Shipping/ship.png": 2412,
	"./Shipping/shipping.png": 2413,
	"./Shipping/smartphone.png": 2414,
	"./Shipping/stroller.png": 2415,
	"./Shipping/support.png": 2416,
	"./Shipping/train.png": 2417,
	"./Shipping/up.png": 2418,
	"./Shipping/warehouse-1.png": 2419,
	"./Shipping/warehouse-2.png": 2420,
	"./Shipping/warehouse.png": 2421,
	"./Shipping/weight.png": 2422,
	"./Shipping/worldwide.png": 2423,
	"./Tools/atomic.png": 2424,
	"./Tools/awl.png": 2425,
	"./Tools/axe.png": 2426,
	"./Tools/barrels.png": 2427,
	"./Tools/battery-1.png": 2428,
	"./Tools/battery.png": 2429,
	"./Tools/box.png": 2430,
	"./Tools/charging.png": 2431,
	"./Tools/chisel.png": 2432,
	"./Tools/clamp.png": 2433,
	"./Tools/coal.png": 2434,
	"./Tools/compass.png": 2435,
	"./Tools/cutter.png": 2436,
	"./Tools/driller.png": 2437,
	"./Tools/ecology.png": 2438,
	"./Tools/electric-car.png": 2439,
	"./Tools/electric-tower.png": 2440,
	"./Tools/eolic-energy.png": 2441,
	"./Tools/factory.png": 2442,
	"./Tools/faucet.png": 2443,
	"./Tools/file.png": 2444,
	"./Tools/gas-station.png": 2445,
	"./Tools/gas.png": 2446,
	"./Tools/glue.png": 2447,
	"./Tools/hammer-1.png": 2448,
	"./Tools/hammer-2.png": 2449,
	"./Tools/hammer.png": 2450,
	"./Tools/house.png": 2451,
	"./Tools/hydro-power.png": 2452,
	"./Tools/jigsaw.png": 2453,
	"./Tools/ladder.png": 2454,
	"./Tools/level.png": 2455,
	"./Tools/light-bulb.png": 2456,
	"./Tools/low-battery.png": 2457,
	"./Tools/marker.png": 2458,
	"./Tools/mat.png": 2459,
	"./Tools/measuring-tape.png": 2460,
	"./Tools/nail.png": 2461,
	"./Tools/needle.png": 2462,
	"./Tools/nut.png": 2463,
	"./Tools/oil-platform.png": 2464,
	"./Tools/paint-brush-1.png": 2465,
	"./Tools/paint-brush-2.png": 2466,
	"./Tools/paint-brush.png": 2467,
	"./Tools/paint-bucket.png": 2468,
	"./Tools/paint-palette.png": 2469,
	"./Tools/paint-roller.png": 2470,
	"./Tools/pantone.png": 2471,
	"./Tools/pencil.png": 2472,
	"./Tools/pliers-1.png": 2473,
	"./Tools/pliers-2.png": 2474,
	"./Tools/pliers.png": 2475,
	"./Tools/plug.png": 2476,
	"./Tools/power-button.png": 2477,
	"./Tools/power-plant.png": 2478,
	"./Tools/rain.png": 2479,
	"./Tools/recycle.png": 2480,
	"./Tools/renewable-energy-1.png": 2481,
	"./Tools/renewable-energy.png": 2482,
	"./Tools/ruler-1.png": 2483,
	"./Tools/ruler.png": 2484,
	"./Tools/save-energy.png": 2485,
	"./Tools/saw-1.png": 2486,
	"./Tools/saw.png": 2487,
	"./Tools/scissors.png": 2488,
	"./Tools/screw.png": 2489,
	"./Tools/screwdriver.png": 2490,
	"./Tools/set-square.png": 2491,
	"./Tools/shovel-1.png": 2492,
	"./Tools/shovel.png": 2493,
	"./Tools/socket.png": 2494,
	"./Tools/solar-energy.png": 2495,
	"./Tools/spatula.png": 2496,
	"./Tools/tape.png": 2497,
	"./Tools/toolbox.png": 2498,
	"./Tools/usb-cable.png": 2499,
	"./Tools/workplace.png": 2500,
	"./Tools/wrench-1.png": 2501,
	"./Tools/wrench-2.png": 2502,
	"./Tools/wrench.png": 2503,
	"./Traffic/001-highway-1.png": 2504,
	"./Traffic/002-two-ways.png": 2505,
	"./Traffic/003-road-sign.png": 2506,
	"./Traffic/004-barrier.png": 2507,
	"./Traffic/005-right-arrow.png": 2508,
	"./Traffic/006-roundabout.png": 2509,
	"./Traffic/007-prohibition.png": 2510,
	"./Traffic/008-curves.png": 2511,
	"./Traffic/009-intersection-3.png": 2512,
	"./Traffic/010-caravan-1.png": 2513,
	"./Traffic/011-caravan.png": 2514,
	"./Traffic/012-highway.png": 2515,
	"./Traffic/013-traffic-sign-1.png": 2516,
	"./Traffic/014-traffic-sign.png": 2517,
	"./Traffic/015-warning-2.png": 2518,
	"./Traffic/016-gas-station.png": 2519,
	"./Traffic/017-turn-right-2.png": 2520,
	"./Traffic/018-coffee-shop.png": 2521,
	"./Traffic/019-bicycle-1.png": 2522,
	"./Traffic/020-bicycle.png": 2523,
	"./Traffic/021-bump.png": 2524,
	"./Traffic/022-intersection-2.png": 2525,
	"./Traffic/023-turn-1.png": 2526,
	"./Traffic/024-turn-right-1.png": 2527,
	"./Traffic/025-turn-left-1.png": 2528,
	"./Traffic/026-intersection-1.png": 2529,
	"./Traffic/027-intersection.png": 2530,
	"./Traffic/028-waiting.png": 2531,
	"./Traffic/029-horn.png": 2532,
	"./Traffic/030-narrow-road.png": 2533,
	"./Traffic/031-warning-1.png": 2534,
	"./Traffic/032-hill.png": 2535,
	"./Traffic/033-truck.png": 2536,
	"./Traffic/034-pedestrian-2.png": 2537,
	"./Traffic/035-pedestrian-1.png": 2538,
	"./Traffic/036-traffic-light.png": 2539,
	"./Traffic/037-turn.png": 2540,
	"./Traffic/038-slippery.png": 2541,
	"./Traffic/039-no-entry.png": 2542,
	"./Traffic/040-speed-limit.png": 2543,
	"./Traffic/041-humps.png": 2544,
	"./Traffic/042-falling-rocks.png": 2545,
	"./Traffic/043-pedestrian.png": 2546,
	"./Traffic/044-turn-right.png": 2547,
	"./Traffic/045-turn-left.png": 2548,
	"./Traffic/046-u-turn.png": 2549,
	"./Traffic/047-warning.png": 2550,
	"./Traffic/048-no-parking.png": 2551,
	"./Traffic/049-parking.png": 2552,
	"./Traffic/050-danger.png": 2553,
	"./Trailers/BoxTrailer_Black.png": 2554,
	"./Trailers/BoxTrailer_Blue.png": 2555,
	"./Trailers/BoxTrailer_Green.png": 2556,
	"./Trailers/BoxTrailer_Grey.png": 2557,
	"./Trailers/BoxTrailer_Red.png": 2558,
	"./Trailers/BoxTrailer_Yellow.png": 2559,
	"./Trailers/Caravan_Black.png": 2560,
	"./Trailers/Caravan_Blue.png": 2561,
	"./Trailers/Caravan_Green.png": 2562,
	"./Trailers/Caravan_Grey.png": 2563,
	"./Trailers/Caravan_Red.png": 2564,
	"./Trailers/Caravan_Yellow.png": 2565,
	"./Trailers/FullTrailer_Black.png": 2566,
	"./Trailers/FullTrailer_Blue.png": 2567,
	"./Trailers/FullTrailer_Green.png": 2568,
	"./Trailers/FullTrailer_Grey.png": 2569,
	"./Trailers/FullTrailer_Red.png": 2570,
	"./Trailers/FullTrailer_Yellow.png": 2571,
	"./Trailers/SuperSilentGeneratorTrailer_Black.png": 2572,
	"./Trailers/SuperSilentGeneratorTrailer_Blue.png": 2573,
	"./Trailers/SuperSilentGeneratorTrailer_Green.png": 2574,
	"./Trailers/SuperSilentGeneratorTrailer_Grey.png": 2575,
	"./Trailers/SuperSilentGeneratorTrailer_Red.png": 2576,
	"./Trailers/SuperSilentGeneratorTrailer_Yellow.png": 2577,
	"./Trailers/TankerTrailer_Black.png": 2578,
	"./Trailers/TankerTrailer_Blue.png": 2579,
	"./Trailers/TankerTrailer_Green.png": 2580,
	"./Trailers/TankerTrailer_Grey.png": 2581,
	"./Trailers/TankerTrailer_Red.png": 2582,
	"./Trailers/TankerTrailer_Yellow.png": 2583,
	"./Trailers/TravelTrailer_Black.png": 2584,
	"./Trailers/TravelTrailer_Blue.png": 2585,
	"./Trailers/TravelTrailer_Green.png": 2586,
	"./Trailers/TravelTrailer_Grey.png": 2587,
	"./Trailers/TravelTrailer_Red.png": 2588,
	"./Trailers/TravelTrailer_Yellow.png": 2589,
	"./Trailers/WaterBowserTrailer_Black.png": 2590,
	"./Trailers/WaterBowserTrailer_Blue.png": 2591,
	"./Trailers/WaterBowserTrailer_Green.png": 2592,
	"./Trailers/WaterBowserTrailer_Grey.png": 2593,
	"./Trailers/WaterBowserTrailer_Red.png": 2594,
	"./Trailers/WaterBowserTrailer_Yellow.png": 2595,
	"./Transportation/aeroplane.png": 2596,
	"./Transportation/airplane.png": 2597,
	"./Transportation/auto-ricksaw.png": 2598,
	"./Transportation/bike.png": 2599,
	"./Transportation/boat.png": 2600,
	"./Transportation/bus-1.png": 2601,
	"./Transportation/bus.png": 2602,
	"./Transportation/cable-car-cabin.png": 2603,
	"./Transportation/car-1.png": 2604,
	"./Transportation/car-2.png": 2605,
	"./Transportation/car-3.png": 2606,
	"./Transportation/car.png": 2607,
	"./Transportation/catamaran.png": 2608,
	"./Transportation/chairlift.png": 2609,
	"./Transportation/classic-car.png": 2610,
	"./Transportation/helicopter.png": 2611,
	"./Transportation/hot-air-balloon.png": 2612,
	"./Transportation/jeep.png": 2613,
	"./Transportation/locomotive.png": 2614,
	"./Transportation/lorry.png": 2615,
	"./Transportation/minibus.png": 2616,
	"./Transportation/monorail.png": 2617,
	"./Transportation/motorbike.png": 2618,
	"./Transportation/quad.png": 2619,
	"./Transportation/sailboat.png": 2620,
	"./Transportation/sailing-ship.png": 2621,
	"./Transportation/school-bus.png": 2622,
	"./Transportation/ship-1.png": 2623,
	"./Transportation/ship-2.png": 2624,
	"./Transportation/ship-3.png": 2625,
	"./Transportation/ship.png": 2626,
	"./Transportation/sidecar.png": 2627,
	"./Transportation/spaceship.png": 2628,
	"./Transportation/sportive-car.png": 2629,
	"./Transportation/submarine.png": 2630,
	"./Transportation/taxi-1.png": 2631,
	"./Transportation/taxi.png": 2632,
	"./Transportation/tractor.png": 2633,
	"./Transportation/train-1.png": 2634,
	"./Transportation/train-2.png": 2635,
	"./Transportation/train.png": 2636,
	"./Transportation/tram.png": 2637,
	"./Transportation/tricycle.png": 2638,
	"./Transportation/trolleybus.png": 2639,
	"./Transportation/truck.png": 2640,
	"./Transportation/ufo.png": 2641,
	"./Transportation/underground.png": 2642,
	"./Transportation/van-1.png": 2643,
	"./Transportation/van.png": 2644,
	"./Transportation/zeppelin.png": 2645,
	"./Trucks/BinTruck_Black.png": 2646,
	"./Trucks/BinTruck_Blue.png": 2647,
	"./Trucks/BinTruck_Green.png": 2648,
	"./Trucks/BinTruck_Grey.png": 2649,
	"./Trucks/BinTruck_Red.png": 2650,
	"./Trucks/BinTruck_Yellow.png": 2651,
	"./Trucks/FuelTankTruck_Black.png": 2652,
	"./Trucks/FuelTankTruck_Blue.png": 2653,
	"./Trucks/FuelTankTruck_Green.png": 2654,
	"./Trucks/FuelTankTruck_Grey.png": 2655,
	"./Trucks/FuelTankTruck_Red.png": 2656,
	"./Trucks/FuelTankTruck_Yellow.png": 2657,
	"./Trucks/HaulTruck_Black.png": 2658,
	"./Trucks/HaulTruck_Blue.png": 2659,
	"./Trucks/HaulTruck_Green.png": 2660,
	"./Trucks/HaulTruck_Grey.png": 2661,
	"./Trucks/HaulTruck_Red.png": 2662,
	"./Trucks/HaulTruck_Yellow.png": 2663,
	"./Trucks/LorryCab_Black.png": 2664,
	"./Trucks/LorryCab_Blue.png": 2665,
	"./Trucks/LorryCab_Green.png": 2666,
	"./Trucks/LorryCab_Grey.png": 2667,
	"./Trucks/LorryCab_Red.png": 2668,
	"./Trucks/LorryCab_Yellow.png": 2669,
	"./Trucks/LorryTrailer_Black.png": 2670,
	"./Trucks/LorryTrailer_Blue.png": 2671,
	"./Trucks/LorryTrailer_Green.png": 2672,
	"./Trucks/LorryTrailer_Grey.png": 2673,
	"./Trucks/LorryTrailer_Red.png": 2674,
	"./Trucks/LorryTrailer_Yellow.png": 2675,
	"./Trucks/Lorry_Black.png": 2676,
	"./Trucks/Lorry_Blue.png": 2677,
	"./Trucks/Lorry_Green.png": 2678,
	"./Trucks/Lorry_Grey.png": 2679,
	"./Trucks/Lorry_Red.png": 2680,
	"./Trucks/Lorry_Yellow.png": 2681,
	"./Trucks/PetroleumTankTruck_Black.png": 2682,
	"./Trucks/PetroleumTankTruck_Blue.png": 2683,
	"./Trucks/PetroleumTankTruck_Green.png": 2684,
	"./Trucks/PetroleumTankTruck_Grey.png": 2685,
	"./Trucks/PetroleumTankTruck_Red.png": 2686,
	"./Trucks/PetroleumTankTruck_Yellow.png": 2687,
	"./Trucks/SkipTruck_Black.png": 2688,
	"./Trucks/SkipTruck_Blue.png": 2689,
	"./Trucks/SkipTruck_Green.png": 2690,
	"./Trucks/SkipTruck_Grey.png": 2691,
	"./Trucks/SkipTruck_Red.png": 2692,
	"./Trucks/SkipTruck_Yellow.png": 2693,
	"./Trucks/TankerTruck_Black.png": 2694,
	"./Trucks/TankerTruck_Blue.png": 2695,
	"./Trucks/TankerTruck_Green.png": 2696,
	"./Trucks/TankerTruck_Grey.png": 2697,
	"./Trucks/TankerTruck_Red.png": 2698,
	"./Trucks/TankerTruck_Yellow.png": 2699,
	"./Trucks/TractorTrailer2_Black.png": 2700,
	"./Trucks/TractorTrailer2_Blue.png": 2701,
	"./Trucks/TractorTrailer2_Green.png": 2702,
	"./Trucks/TractorTrailer2_Grey.png": 2703,
	"./Trucks/TractorTrailer2_Red.png": 2704,
	"./Trucks/TractorTrailer2_Yellow.png": 2705,
	"./Trucks/TractorTrailer_Black.png": 2706,
	"./Trucks/TractorTrailer_Blue.png": 2707,
	"./Trucks/TractorTrailer_Green.png": 2708,
	"./Trucks/TractorTrailer_Grey.png": 2709,
	"./Trucks/TractorTrailer_Red.png": 2710,
	"./Trucks/TractorTrailer_Yellow.png": 2711,
	"./Trucks/TruckV_Black.png": 2712,
	"./Trucks/TruckV_Blue.png": 2713,
	"./Trucks/TruckV_Green.png": 2714,
	"./Trucks/TruckV_Grey.png": 2715,
	"./Trucks/TruckV_Red.png": 2716,
	"./Trucks/TruckV_Yellow.png": 2717,
	"./Trucks/Truck_Black.png": 2718,
	"./Trucks/Truck_Blue.png": 2719,
	"./Trucks/Truck_Green.png": 2720,
	"./Trucks/Truck_Grey.png": 2721,
	"./Trucks/Truck_Red.png": 2722,
	"./Trucks/Truck_Yellow.png": 2723,
	"./Watercraft/Barge_Black.png": 2724,
	"./Watercraft/Barge_Blue.png": 2725,
	"./Watercraft/Barge_Green.png": 2726,
	"./Watercraft/Barge_Grey.png": 2727,
	"./Watercraft/Barge_Red.png": 2728,
	"./Watercraft/Barge_Yellow.png": 2729,
	"./Watercraft/Boat_Black.png": 2730,
	"./Watercraft/Boat_Blue.png": 2731,
	"./Watercraft/Boat_Gray.png": 2732,
	"./Watercraft/Boat_Green.png": 2733,
	"./Watercraft/Boat_Red.png": 2734,
	"./Watercraft/Boat_Yellow.png": 2735,
	"./Watercraft/BulkCarrier_Black.png": 2736,
	"./Watercraft/BulkCarrier_Blue.png": 2737,
	"./Watercraft/BulkCarrier_Green.png": 2738,
	"./Watercraft/BulkCarrier_Grey.png": 2739,
	"./Watercraft/BulkCarrier_Red.png": 2740,
	"./Watercraft/BulkCarrier_Yellow.png": 2741,
	"./Watercraft/Motorboat_Black.png": 2742,
	"./Watercraft/Motorboat_Blue.png": 2743,
	"./Watercraft/Motorboat_Green.png": 2744,
	"./Watercraft/Motorboat_Grey.png": 2745,
	"./Watercraft/Motorboat_Red.png": 2746,
	"./Watercraft/Motorboat_Yellow.png": 2747,
	"./Watercraft/Sailboat_Black.png": 2748,
	"./Watercraft/Sailboat_Blue.png": 2749,
	"./Watercraft/Sailboat_Green.png": 2750,
	"./Watercraft/Sailboat_Grey.png": 2751,
	"./Watercraft/Sailboat_Red.png": 2752,
	"./Watercraft/Sailboat_Yellow.png": 2753,
	"./Watercraft/Tanker_Black.png": 2754,
	"./Watercraft/Tanker_Blue.png": 2755,
	"./Watercraft/Tanker_Green.png": 2756,
	"./Watercraft/Tanker_Grey.png": 2757,
	"./Watercraft/Tanker_Red.png": 2758,
	"./Watercraft/Tanker_Yellow.png": 2759,
	"./Watercraft/WaterMotorcycle_Black.png": 2760,
	"./Watercraft/WaterMotorcycle_Blue.png": 2761,
	"./Watercraft/WaterMotorcycle_Green.png": 2762,
	"./Watercraft/WaterMotorcycle_Grey.png": 2763,
	"./Watercraft/WaterMotorcycle_Red.png": 2764,
	"./Watercraft/WaterMotorcycle_Yellow.png": 2765
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51;